<template>
  <div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
      <div class="w-full" v-if="title">
        <h6 class="pt-2">{{ title }}</h6>
      </div>
      <DxButton
        style="margin-left: 5px;"
        icon="export"
        type="normal"
        @click="exportToExcel"
      />
    </div>
    <DxDataGrid
      id="historicalReport"
      ref="historicalReport"
      :data-source="items"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :show-borders="true"
      :column-resizing-mode="'nextColumn'"
      :column-min-width="100"
      :column-auto-width="true"
    >
      <!-- Paging and Pager -->
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 20, 50]"
        :show-info="true"
      />

      <!-- Activate Filter -->
      <DxFilterRow :visible="true" />

      <DxColumn
        data-type="date"
        data-field="date"
        :caption="dateColumnLabel()"
        fixed-position="left"
        :format="getDateFormat()"
        :fixed="true"
      />

      <template v-for="(asset, index) in assets" v-if="assets.length">
        <DxColumn
          :caption="unit ? `${asset} (${unit})` : asset"
          :data-field="asset"
          :alignment="unit !== 'MYR' ? 'right' : 'left'"
          data-type="string"
        />
      </template>

      <template
        v-for="(asset, index) in assetsProperties"
        v-if="assetsProperties.length"
      >
        <DxColumn
          :caption="asset.name"
          :data-field="asset.name"
          data-type="string"
        >
          <template v-for="(property, key) in asset.children">
            <template v-for="(field, caption) of property">
              <DxColumn
                :caption="unit ? `${caption} (${unit})` : caption"
                :data-field="field"
                :alignment="unit !== 'MYR' ? 'right' : 'left'"
                data-type="string"
              />
            </template>
          </template>
        </DxColumn>
      </template>
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow
} from 'devextreme-vue/data-grid'
import { exportDataGrid } from 'devextreme/excel_exporter'
import ExcelJS from 'exceljs'
import saveAs from 'file-saver'
import DxButton from 'devextreme-vue/button'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxButton
  },
  props: {
    title: {
      type: String
    },
    type: {
      type: String
    },
    items: {
      type: Array
    },
    assets: {
      type: Array
    },
    assetsProperties: {
      type: Array
    },
    unit: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    getDateFormat() {
      if (this.type === 'monthly') {
        return `MMMM yyyy`
      } else if (this.type === 'yearly') {
        return `yyyy`
      } else {
        return `d MMMM yyyy`
      }
    },
    getDateOnly(value) {
      var date = value.split('-')
      return date[date.length - 1]
    },
    dateColumnLabel() {
      if (this.type === 'monthly') {
        return 'Month'
      } else if (this.type === 'yearly') {
        return 'Year'
      } else {
        return 'Date'
      }
    },
    exportToExcel() {
      const context = this
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Historical Report')

      exportDataGrid({
        component: context.datagridInstance,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `${this.title}.xlsx`
          )
        })
      })
    },
    elog(log) {
      console.log('HistoricalReport', log)
    }
  },
  computed: {
    datagridInstance: function () {
      return this.$refs.historicalReport.instance
    }
  }
}
</script>
